export default "__VITE_PUBLIC_ASSET__b17050e1__"